export function useEnvironmentVariables() {
    return {
        VITE_HUBSPOT_AUTHENTICATION_URI: import.meta.env.VITE_HUBSPOT_AUTHENTICATION_URI as string,
        VITE_PIPEDRIVE_AUTHENTICATION_URI: import.meta.env.VITE_PIPEDRIVE_AUTHENTICATION_URI as string,
        VITE_SALESFORCE_AUTHENTICATION_URI: import.meta.env.VITE_SALESFORCE_AUTHENTICATION_URI as string,
    };
}
